import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";
import { ChannelEventFactory } from "../pb-screen/services/channel.event.factory";
import { ChannelService } from "../pb-screen/services/channel.service";
import { ActionKeys } from "../pb-screen/action.keys" ;
import { HashService } from  "../shared/services/hash.service";
import { SignalrBroadcaster } from "../pb-screen/helpers/signalr.broadcaster";
import { IAppState } from "../store/IAppState";

@Injectable()
export class UserAuthorizationActions extends SignalrBroadcaster{

    constructor(
        ngRedux: NgRedux<IAppState>,
        channelEventFactory: ChannelEventFactory,
        channelService: ChannelService,
    ) {
        super(ngRedux, channelEventFactory, channelService);
    }

    public setAllUsers(users: any[]) {
        super.dispatchAction({
            type: ActionKeys.GET_ALL_AZURE_USERS,
            azureUsers: users
        });
    }

    public setSelectedAzureUsers(users : any[]) {
        super.dispatchAction({
            type: ActionKeys.SET_SELECTED_AZURE_USERS,
            selectedAzureUsers: users
        });
    }

    public filterUsers(searchText : string) {
        super.dispatchAction({
            type: ActionKeys.FILTER_USERS,
            searchText
          });
    }
}